// extracted by mini-css-extract-plugin
export default {"saveCocktail":"savecocktail_saveCocktail__esVHy","saveCocktails":"savecocktail_saveCocktails__22rui"};